import { useState, useEffect } from "react";
import { PlusCircle } from "lucide-react";
import { useTableStore } from "@/store/tableStore";
import { Button } from "@/components/ui/button";
import { TablesList } from "@/components/tables/TablesList";
import { AddTableDialog } from "@/components/tables/AddTableDialog";
import { StoreSelector } from "@/components/menu/StoreSelector";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { QrCodeDialog } from "@/components/tables/QrCodeDialog";
import { useTranslation } from "react-i18next";
import { useStoreManagementStore } from "@/store/storeManagement";
const TablesManagement = () => {
  const { tables, setSelectedStoreId } = useTableStore();
  const { selectedStoreId } = useStoreManagementStore();
  const [showAddDialog, setShowAddDialog] = useState(false);
  const [selectedTableId, setSelectedTableId] = useState<string | null>(null);
  const [showQrDialog, setShowQrDialog] = useState(false);
  const { t } = useTranslation();

  const totalTables = tables.length;
  const totalScans = tables.reduce((sum, table) => sum + table.daily_scans, 0);
  const totalScansAllTime = tables.reduce(
    (sum, table) => sum + table.total_scans,
    0
  );

  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">
            {t("qrCodesAndTables")}
          </h1>
          <p className="text-muted-foreground mt-1">
            {t("manageYourStoreTablesAndQrCodes")}
          </p>
        </div>
        <div className="flex flex-col sm:flex-row gap-3">
          <Button
            onClick={() => setShowAddDialog(true)}
            disabled={!selectedStoreId}
            className="w-full sm:w-auto"
          >
            <PlusCircle className="mr-2 h-4 w-4" />
            {t("addNewTable")}
          </Button>
        </div>
      </div>

      {selectedStoreId && (
        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          <Card>
            <CardHeader className="pb-2">
              <CardTitle>{t("totalTables")}</CardTitle>
              <CardDescription>
                {t("numberOfTablesInYourStore")}
              </CardDescription>
            </CardHeader>
            <CardContent>
              <div className="text-3xl font-bold">{totalTables}</div>
            </CardContent>
          </Card>
          <Card>
            <CardHeader className="pb-2">
              <CardTitle>{t("todaysScans")}</CardTitle>
              <CardDescription>{t("totalQrCodeScansToday")}</CardDescription>
            </CardHeader>
            <CardContent>
              <div className="text-3xl font-bold">{totalScans}</div>
            </CardContent>
          </Card>
          <Card>
            <CardHeader className="pb-2">
              <CardTitle>{t("allTimeScans")}</CardTitle>
              <CardDescription>{t("totalQrCodeScansAllTime")}</CardDescription>
            </CardHeader>
            <CardContent>
              <div className="text-3xl font-bold">{totalScansAllTime}</div>
            </CardContent>
          </Card>
        </div>
      )}

      <TablesList />

      <AddTableDialog open={showAddDialog} onOpenChange={setShowAddDialog} />

      <QrCodeDialog
        open={showQrDialog}
        onOpenChange={setShowQrDialog}
        tableId={selectedTableId}
      />
    </div>
  );
};

export default TablesManagement;
